import { useState } from 'react';
import { pushImageUrl } from './helpers';

function ImagePreview({ src, thumbnail }) {
    const [failed, setFailed] = useState(false);
    return failed
        ? <div className={`push-campaign-image-error${thumbnail ? ' push-campaign-image-thumbnail' : ''}`} role="img" aria-label="通知图片加载失败">{thumbnail ? '图片' : '图片加载失败'}</div>
        : <img className={`push-campaign-image${thumbnail ? ' push-campaign-image-thumbnail' : ''}`} src={src} alt="通知图片" referrerPolicy="no-referrer" onError={() => setFailed(true)} />;
}

export default function PushImage({ url, thumbnail = false }) {
    const src = pushImageUrl(url);
    return src ? <ImagePreview key={src} src={src} thumbnail={thumbnail} /> : null;
}
